import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { ArrowLeft } from 'lucide-react';
import { motion } from 'framer-motion';
import Navbar from '../components/sections/Navbar';
import Footer from '../components/sections/Footer';
import LeadershipTeam from '../components/sections/LeadershipTeam';
import CrewSection from '../components/sections/CrewSection';

export default function TeamPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background" data-testid="team-page">
      <Navbar />
      <main id="main-content" tabIndex={-1}>

      {/* Page hero */}
      <section className="relative pt-16 pb-12 sm:pt-20 sm:pb-14 bg-coal text-bone overflow-hidden">
        <div className="absolute inset-0 bg-grain opacity-[0.05] pointer-events-none" />
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <Button
            variant="ghost"
            onClick={() => navigate('/')}
            className="text-bone/60 hover:text-bone hover:bg-white/10 mb-6 -ml-2 gap-2"
            data-testid="team-back-button"
          >
            <ArrowLeft className="w-4 h-4" />
            Back to Home
          </Button>
          <motion.div
            initial={{ opacity: 0, y: 14 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="max-w-3xl"
          >
            <p className="kicker kicker-on-dark mb-4">The team</p>
            <h1 className="editorial-headline text-4xl sm:text-5xl lg:text-6xl text-bone mb-5" data-testid="team-page-headline">
              Conway, Arkansas.
              <span className="italic font-normal text-forest-2"> The </span>
              people who build it.
            </h1>
            <p className="text-bone/70 leading-[1.75] text-[15px] max-w-2xl">
              OMC operates from one central headquarters with direct oversight on every
              project. Our administrative team stays closely involved from preconstruction
              through closeout, while our own field crews execute the work on site. That
              structure keeps communication clear, accountability direct, and quality
              control in our hands.
            </p>
          </motion.div>
        </div>
      </section>

      <LeadershipTeam />
      <CrewSection />
      </main>
      <Footer />
    </div>
  );
}
